import { doGETRequest, doPOSTRequest, doPUTRequest } from "./Api";

class BuyerApi {
  private static basePath = "/buyers";

  public static async createOrUpdate(data: any) {
    if (data.id) {
      return this.update(data);
    }
    return this.create(data);
  }

  public static async create(data: any) {
    return await doPOSTRequest(this.basePath, data);
  }

  public static async update(data: any) {
    return await doPUTRequest(this.basePath, data);
  }

  public static async listAll() {
    return await doGETRequest(this.basePath);
  }

  public static async listAllCards() {
      return await doGETRequest(`${this.basePath}/cards`);
  }

  public static async syncExternalBuyers() {
      // Burada backend endpoint’in URL’i:
      return await doGETRequest(`${this.basePath}/sync-external-buyers`);
    }
}

export default BuyerApi;
